import {
  BASE_URL,
  FACILITIES,
  FACILITIES_DATA,
  GET_FACILITIES,
  ERROR_MSG,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchFacilitiesData = async (
  pageNo,
  recordsPerPage,
  urlWithParams
) => {
  let response = await fetch(
    `${BASE_URL}${FACILITIES_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const getAllFacilities = async () => {
  let response = await fetch(`${BASE_URL}${GET_FACILITIES}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const addNewFacility = async (form) => {
  let response = await fetch(`${BASE_URL}${FACILITIES}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const fetchFacilityById = async (sendingFacilityId) => {
  let response = await fetch(`${BASE_URL}${FACILITIES}/${sendingFacilityId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateFacilityRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${FACILITIES}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const removeFacilityRecord = async (sendingFacilityId) => {
  let response = await fetch(`${BASE_URL}${FACILITIES}/${sendingFacilityId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (!response.ok) {
    return ERROR_MSG;
  }
};
